import './ProductToolMessageBox.less';
import React, {useState, useEffect} from 'react';
import Icon from '../../../components/icon/Icon';


export default function ProductToolMessageBox({
    children,
    message,
}) {

    return <div className="product-tool-message-box">
        <Icon name="caution-circle"/>

        <div className="text">
            {children || message}
        </div>
    </div>;
}
